import React from "react";
const DotDotDot = ({ children }) => (
  <div
    style={{
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      flex: 1
    }}
  >
    {children}
  </div>
);
export default DotDotDot;
